import React from 'react'
import PropTypes from 'prop-types'
import GoalBubbleNavigator from './GoalBubbleNavigator'
import GoalContentPanel from './GoalContentPanel'
import PlanPageContent from './PlanPageContent'
import PlaybookHeader from './PlaybookHeader'
import StepPageNavigator from './StepPageNavigator'
import { PlaybookStepsWrapper } from './component.styles'

const PlaybookSteps = ({
  activePanel,
  activeStep,
  classCreationGoalValue,
  goal1Date,
  goal1IsCompleted,
  goal2Date,
  goal2IsCompleted,
  goal3Date,
  goal3IsCompleted,
  goal3Text,
  goal4Date,
  goal4IsCompleted,
  goal4Text,
  goal5Date,
  goal5IsCompleted,
  goal5Text,
  goalsAreCompleted,
  goalsIsInDraft,
  goalsOnlyMode,
  hasAllStepsCompleted,
  implementationApproachIsCompleted,
  isModalOpen,
  isSingleSite,
  lessonCompletionGoalIsDisabled,
  lessonCompletionGoalValue,
  linkDropdownDisplayTitle,
  linkMenu,
  modalComponent,
  navigationEvent,
  onCloseModal,
  onDropdownLinkSelect,
  onGoalSelect,
  onModalClose,
  onOpenAllStaffModal,
  onOpenFamiliesModal,
  onOpenGoalsModal,
  onOpenGoalsModalFromWarning,
  onOpenStepModal,
  onOpenSummaryModal,
  onStepClick,
  programStartDate,
  purposeIsCompleted,
  purposeIsInDraft,
  selectedGoal,
  showHeader,
  showMonitorViewOnly,
  showSummary,
  siteId,
  sitePlaybookData,
  siteUserStats,
}) => {
  const Modal = modalComponent

  return (
    <PlaybookStepsWrapper
      isSingleSite={isSingleSite}
      showHeader={showHeader}
      showMonitorViewOnly={showMonitorViewOnly}
    >
      {showHeader && (
        <PlaybookHeader
          hasAllStepsCompleted={hasAllStepsCompleted}
          onOpenSummaryModal={onOpenSummaryModal}
          showMonitorViewOnly={showMonitorViewOnly}
          showSummary={showSummary}
        />
      )}
      {showMonitorViewOnly && (
        <>
          <GoalBubbleNavigator
            goal3IsCompleted={goal3IsCompleted}
            goal4IsCompleted={goal4IsCompleted}
            goal5IsCompleted={goal5IsCompleted}
            onGoalSelect={onGoalSelect}
            selectedGoal={selectedGoal}
            showHeader={showHeader}
            showMonitorViewOnly={showMonitorViewOnly}
          />
          <GoalContentPanel
            classCreationGoalValue={classCreationGoalValue}
            goal1Date={goal1Date}
            goal2Date={goal2Date}
            goal3Date={goal3Date}
            goal3IsCompleted={goal3IsCompleted}
            goal3Text={goal3Text}
            goal4Date={goal4Date}
            goal4IsCompleted={goal4IsCompleted}
            goal4Text={goal4Text}
            goal5Date={goal5Date}
            goal5IsCompleted={goal5IsCompleted}
            goal5Text={goal5Text}
            isSingleSite={isSingleSite}
            lessonCompletionGoalIsDisabled={lessonCompletionGoalIsDisabled}
            lessonCompletionGoalValue={lessonCompletionGoalValue}
            navigationEvent={navigationEvent}
            onOpenGoalsModal={onOpenGoalsModal}
            onOpenGoalsModalFromWarning={onOpenGoalsModalFromWarning}
            programStartDate={programStartDate}
            selectedGoal={selectedGoal}
            showHeader={showHeader}
            showMonitorViewOnly={showMonitorViewOnly}
            siteId={siteId}
            sitePlaybookData={sitePlaybookData}
            siteUserStats={siteUserStats}
          />
        </>
      )}
      {!showMonitorViewOnly && (
        <PlanPageContent
          activePanel={activePanel}
          activeStep={activeStep}
          goalsIsInDraft={goalsIsInDraft}
          linkDropdownDisplayTitle={linkDropdownDisplayTitle}
          linkMenu={linkMenu}
          onDropdownLinkSelect={onDropdownLinkSelect}
          onOpenAllStaffModal={onOpenAllStaffModal}
          onOpenFamiliesModal={onOpenFamiliesModal}
          onOpenStepModal={onOpenStepModal}
          purposeIsInDraft={purposeIsInDraft}
          showSummary={showSummary}
        />
      )}
      {!showMonitorViewOnly && !showSummary && (
        <StepPageNavigator
          activeStep={activeStep}
          goalsAreCompleted={goalsAreCompleted}
          implementationApproachIsCompleted={implementationApproachIsCompleted}
          onStepClick={onStepClick}
          purposeIsCompleted={purposeIsCompleted}
        />
      )}
      {isModalOpen && Modal && (
        <Modal
          goalsOnlyMode={goalsOnlyMode}
          handleCancel={onCloseModal}
          handleClose={goalsOnlyMode ? onCloseModal : onModalClose}
          siteId={siteId}
        />
      )}
    </PlaybookStepsWrapper>
  )
}

PlaybookSteps.propTypes = {
  activePanel: PropTypes.object,
  activeStep: PropTypes.number,
  classCreationGoalValue: PropTypes.number,
  goal1Date: PropTypes.number,
  goal1IsCompleted: PropTypes.bool,
  goal2Date: PropTypes.number,
  goal2IsCompleted: PropTypes.bool,
  goal3Date: PropTypes.number,
  goal3IsCompleted: PropTypes.bool,
  goal3Text: PropTypes.string,
  goal4Date: PropTypes.number,
  goal4IsCompleted: PropTypes.bool,
  goal4Text: PropTypes.string,
  goal5Date: PropTypes.number,
  goal5IsCompleted: PropTypes.bool,
  goal5Text: PropTypes.string,
  goalsAreCompleted: PropTypes.bool,
  goalsIsInDraft: PropTypes.bool,
  goalsOnlyMode: PropTypes.bool,
  hasAllStepsCompleted: PropTypes.bool,
  implementationApproachIsCompleted: PropTypes.bool,
  isModalOpen: PropTypes.bool,
  isSingleSite: PropTypes.bool,
  lessonCompletionGoalIsDisabled: PropTypes.bool,
  lessonCompletionGoalValue: PropTypes.number,
  linkDropdownDisplayTitle: PropTypes.string,
  linkMenu: PropTypes.array,
  modalComponent: PropTypes.elementType,
  navigationEvent: PropTypes.func,
  onCloseModal: PropTypes.func,
  onDropdownLinkSelect: PropTypes.func,
  onGoalSelect: PropTypes.func,
  onModalClose: PropTypes.func,
  onOpenAllStaffModal: PropTypes.func,
  onOpenFamiliesModal: PropTypes.func,
  onOpenGoalsModal: PropTypes.func,
  onOpenGoalsModalFromWarning: PropTypes.func,
  onOpenStepModal: PropTypes.func,
  onOpenSummaryModal: PropTypes.func,
  onStepClick: PropTypes.func,
  programStartDate: PropTypes.number,
  purposeIsCompleted: PropTypes.bool,
  purposeIsInDraft: PropTypes.bool,
  selectedGoal: PropTypes.string,
  showHeader: PropTypes.bool,
  showMonitorViewOnly: PropTypes.bool,
  showSummary: PropTypes.bool,
  siteId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sitePlaybookData: PropTypes.object,
  siteUserStats: PropTypes.shape({
    totalUsers: PropTypes.number,
    usersWithoutClasses: PropTypes.number,
    usersWithoutAccounts: PropTypes.number,
  }),
}

export default PlaybookSteps
